module.exports = __webpack_public_path__ + "img/源代码发布.e358cf59.jpg";